<ion-toolbar>
  <ion-title>{{ 'TITLE.passStatus' | translate }}</ion-title>
</ion-toolbar>


<ion-content class="ion-padding">
  <ion-card>
    <ion-card-content>
      @if (insufficientErrorMessage) {
        <h2 class="error">{{ insufficientErrorMessage }}</h2>
      }
      <dl>
        @for (displayObj of displayStrings; track displayObj) {
          <dt>{{ displayObj.label }}:</dt>
          <dd [class.error]="displayObj.isError">{{ displayObj.value }}</dd>
        }
      </dl>
    </ion-card-content>
  </ion-card>
</ion-content>

<ion-toolbar class="bottom-actions">
  <ion-button expand="block" color="primary" (click)="provideRideClicked()">{{ 'ACTION.provideRide' | translate }}</ion-button>
  <ion-button expand="block" color="danger" (click)="denyRideClicked()">{{ 'ACTION.denyRide' | translate }}</ion-button>
</ion-toolbar>
